import { clearApiClient } from './clearApiClient';
import { logSchemaMismatchError } from './schema/schemaUtils';
import { routerSetupOptionsResponseSchema, type RouterSetupOptionsResponse } from './schema/shortcutSchema';

export const sendRouterSetupOptionsRequest = () =>
  clearApiClient
    .get<RouterSetupOptionsResponse>('/web/v1/shortcut/get-router-setup?protocol=wg', {
      headers: { 'app-version': '3.0.0' },
      meta: {},
    })
    .then((response) => {
      const parseResult = routerSetupOptionsResponseSchema.safeParse(response.data);

      if (!parseResult.success) {
        logSchemaMismatchError(parseResult.error, 'Shortcut options schema mismatch');

        return response.data;
      }

      return parseResult.data;
    });
